export default "/images/radio.svg?597e1dfdc8fb7f6ca87d60a206b48cfb";